export default "__VITE_ASSET__ixPiDQUm__"